module.exports = __WEBPACK_EXTERNAL_MODULE_25__;


//////////////////
// WEBPACK FOOTER
// external "codemirror"
// module id = 25
// module chunks = 0 1